module.exports = __webpack_public_path__ + "fonts/Nunito-Regular.d2e691b.ttf";